import { GetterTree } from 'vuex';
import RootState from '@/store/root_state';
import { PostGradMicrocertificateState } from './state';

const getters: GetterTree<PostGradMicrocertificateState, RootState> = {
  microcertificateEligibilityByClassroomId: (state) => (classroomId: number) => {
    if (!classroomId) return false;
    const eligibility = state.disciplinesMicrocertificateEligibility[classroomId];
    return eligibility || false;
  },
};

export default getters;
